import React from "react";

export const Reset = () => {
  return (
    <svg
      width="65"
      height="56"
      viewBox="0 0 65 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M55.2406 0.568359H6.76111C3.42814 0.568359 0.731472 3.29533 0.731472 6.6283L0.701172 42.9879C0.701172 46.3209 3.42814 49.0478 6.76111 49.0478H31.0009V42.9879H6.76111V12.6882L31.0009 27.8381L55.2406 12.6882V27.8381H61.3005V6.6283C61.3005 3.29533 58.5736 0.568359 55.2406 0.568359ZM31.0009 21.7781L6.76111 6.6283H55.2406L31.0009 21.7781ZM47.1809 55.1078L36.4548 44.3817L40.7271 40.1094L47.1506 46.533L59.9976 33.6859L64.3305 37.9582L47.1809 55.1078Z"
        fill="#605DAF"
      />
    </svg>
  );
};
